<template>
  <div class="desktron">
    <Menu />

    <div class="dt-top">
      <img class="dt-top-logo" src="@/assets/desktron/Desktron.png" />
      <p class="dt-top-desc1">
        Desktron云桌面，高清高性能高可用的<br />安全云桌面
      </p>
      <div class="dt-top-desc2">
        混合桌面模式（虚拟桌面+物理桌面），帮您快速构建安全、高性能、低成本的企业桌面办公体系。可广泛应用于具有高数据安全管控、高性能计算等要求的安全办公、金融、设计、影视、教育等领域
      </div>
      <div class="dt-top-btns">
        <a class="btn-common btn-primary" @click="handleClick">申请试用</a>
        <!-- <a class="btn-common">联系我们</a> -->
      </div>
    </div>

    <Common :path="path" />
    <Footer />
  </div>
</template>
<script>
import Menu from "@/components/menu";
import Footer from "@/components/footer";
import Common from "@/components/Desktron/Common";

export default {
  components: {
    Menu,
    Footer,
    Common,
  },
  data() {
    return {
      path: "/desktron/contact",
    };
  },

  methods: {
    handleClick() {
      this.$router.push({
        path: this.path,
      });
    },
    initHash() {
      this.$nextTick(() => {
        const hashArr = ["application", "solutions", "design"];
        const path = this.$route.params.path;
        if (hashArr.indexOf(path) !== -1) {
          const el = document.querySelector(`#${path}`);
          const headerHeight = document.querySelector(".menu")
            ? document.querySelector(".menu").clientHeight
            : 50;
          window.scrollTo(0, el.offsetTop - headerHeight);
        }
      });
    },
  },
  watch: {
    $route() {
      this.initHash();
    },
  },
  mounted() {
    this.initHash();
  },
};
</script>
<style lang="less" scoped>
.btn-common {
  display: block;
  box-sizing: border-box;
  width: 256px;
  height: 40px;
  border-radius: 4px;
  border: 1px solid rgba(105, 116, 167, 0.22);
  background: #fff;
  color: #0c89e4;
  text-align: center;
  line-height: 38px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #ecf6fd;
    border-color: #0c89e4;
  }

  &:active {
    background-color: #ecf6fd;
    border-color: #0c89e4;
  }
}

.btn-common + .btn-common {
  margin-left: 18px;
}

.btn-primary {
  background-color: #0c89e4;
  color: #ffffff;
  border-color: #0c89e4;

  &:hover {
    background-color: #2495e7;
    border-color: #2495e7;
  }

  &:active {
    background-color: #0b7bcd;
    border-color: #0b7bcd;
  }
}
.dt-top {
  display: flex;
  flex-direction: column;
  align-items: center;

  background-color: #f5faff;

  text-align: center;

  .dt-top-logo {
    width: 159px;
    height: 43px;
    margin-top: 29px;
  }

  .dt-top-desc1 {
    color: #1d2129;
    font-size: 16px;
    line-height: 20px;
    margin-top: 19px;
    padding: 0 20px;
  }

  .dt-top-desc2 {
    color: #86909c;
    font-size: 13px;
    line-height: 20px;
    margin-top: 6px;
    padding: 0 20px;
  }

  .dt-top-btns {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 9px;
    height: 321px;
    background: url("~@/assets/desktron/top.png") center no-repeat;
    background-size: 100% 100%;
    padding-top: 15px;
  }
}
</style>
